import { Component, Input } from '@angular/core';
import { CashBalance } from '../../models';

@Component({
  standalone: false,
  selector: 'mm-cash-balance-list',
  templateUrl: './cash-balance-list.component.html',
  styleUrls: ['./cash-balance-list.component.scss'],  
})

export class CashBalanceListComponent {
  @Input() balances: CashBalance[] | null;
  @Input() formerTdaIndicator: boolean;
}
